export const formatTimestamp = timestamp => {
  return {
    days: Math.floor(timestamp / 1000 / 60 / 60 / 24),
    hours: Math.floor(timestamp / 1000 / 60 / 60) % 24,
    minutes: Math.floor(timestamp / 1000 / 60) % 60,
    seconds: Math.floor(timestamp / 1000) % 60
  };
};